import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import mailpointImage from '../assets/images/mailpoints.png';

const MailpointLeftPanel: FC = () => {
    const {t} = useTranslation('Billing.Mailpoints');

    return (
        <div className="mt-12 flex flex-1 flex-col items-center p-2">
            <img alt="" className="mb-2 w-52" src={mailpointImage} />
            <div className="mt-0 text-center">
                <h2 className="mx-0 mb-0">{t('descriptionTitle')}</h2>
                <p className="subheading">{t('description')}</p>
            </div>
        </div>
    );
};

export default MailpointLeftPanel;
